import { fetchPurchaseOrders, selectPurchaseOrder, resetCurrentPurchaseOrder } from '../../actions/purchaseOrders_actions';
import { fetchWarehouseBins, fetchWarehouses, fetchWarehouseSalesOrders, fetchWarehousePurchaseOrders } from '../../actions/warehouses_actions';
import { fetchInventories, selectInventory, resetCurrentInventory } from '../../actions/inventories_actions';
import { fetchFavorites, selectFavorites, resetCurrentFavorites, deleteFavorite } from '../../actions/favorites_actions';
import { fetchCustomerOrderSchedules, fetchCustomerOrderSchedulesByDate, fetchSalesOrders, fetchSalesCSV, fetchSalesDashboardDetail } from '../../actions/sales_actions';
import { fetchSalesInvoices } from '../../actions/salesInvoice_actions';
import { fetchCustomerCreditByDate } from '../../actions/customers_actions';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';

import SalesDashboard from '../../components/Sales/salesDashboard';

let salesDashboard = reduxForm({
    form: 'salesDashboard',
})(SalesDashboard);

const selector = formValueSelector('salesDashboard');

function mapStateToProps(state) {
    const orderScheduleDate = selector(state, 'OrderScheduleDate');
    const warehouseChosen = selector(state, 'Warehouse');

    return {
        orderScheduleDate,
        warehouseChosen,

        customerOrderSchedules: state.salesOrders.customerOrderSchedules,
        customerOrderSchedulesIsLoading: state.salesOrders.customerOrderSchedulesIsLoading,
        customerOrderSchedulesError: state.salesOrders.customerOrderSchedulesError,

        customerCreditLines: state.customers.customerCreditLines,
        customerCreditLinesIsLoading: state.customers.customerCreditLinesIsLoading,
        customerCreditLinesError: state.customers.customerCreditLinesError,

        salesOrders: state.salesOrders.all,
        SOIsLoading: state.salesOrders.isLoading,
        SOError: state.salesOrders.error,

        salesInvoices: state.salesInvoice.all,
        salesInvoicesIsLoading: state.salesInvoice.isLoading,
        salesInvoicesError: state.salesInvoice.error,

        currentPurchaseOrder: state.purchaseOrders.currentPurchaseOrder,

        purchaseOrders: state.warehouses.purchaseOrders,
        POIsLoading: state.warehouses.purchaseOrdersIsLoading,
        POError: state.warehouses.purchaseOrdersError,

        warehouses: state.warehouses.all,
        warehousesIsLoading: state.warehouses.isLoading,
        warehousesError: state.warehouses.error,

        warehouseBinsDetail: state.warehouses.warehouseBinsDetail,
        warehouseBinsDetailIsLoading: state.warehouses.warehouseBinsDetailIsLoading,
        warehouseBinsDetailError: state.warehouses.warehouseBinsDetailError,

        inventories: state.inventories.all,
        favorites: state.favorites.all,
        inventoryIsLoading: state.inventories.isLoading,
        favoritesAreLoading: state.favorites.isLoading,
        inventoryError: state.inventories.error,
        favoritesError: state.favorites.error,
        currentInventory: state.inventories.currentInventory,
        currentFavorites: state.favorites.currentFavorites,

        dashboardSalesDetail: state.salesOrders.dashboardSalesDetail,
        dashboardSalesDetailIsLoading: state.salesOrders.dashboardSalesDetailIsLoading,
        dashboardSalesDetailError: state.salesOrders.dashboardSalesDetailError,
    };
}

export default connect(mapStateToProps, { fetchPurchaseOrders, selectPurchaseOrder, resetCurrentPurchaseOrder,
                                            fetchInventories, fetchFavorites, selectInventory, selectFavorites,
                                             resetCurrentInventory, resetCurrentFavorites, deleteFavorite,
                                               fetchWarehouses, fetchWarehouseSalesOrders, fetchWarehousePurchaseOrders,
                                                fetchWarehouseBins, fetchCustomerOrderSchedules, fetchSalesOrders, fetchSalesCSV,
                                                 fetchSalesInvoices, fetchCustomerOrderSchedulesByDate, fetchCustomerCreditByDate, fetchSalesDashboardDetail })(salesDashboard);



// WEBPACK FOOTER //
// ./master/jsx/containers/Sales/salesDashboard.jsx